module.exports = __webpack_public_path__ + "static/media/truck-speed.50308803.svg";